/* eslint-disable prefer-const */
/* eslint-disable prefer-template */
/* eslint-disable import/prefer-default-export */
export function toFixed(num: number, fixed: number) {
    let re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
    const value = num.toString(2).match(re)[0];

    return parseFloat(value);
}
